










































































































































import { PopRoute, AddRoute, ReplaceRoute } from '../../types/store';
import {Vue, Component, Prop} from 'vue-property-decorator';
import {Action, Getter, Mutation, State} from "vuex-class";
import AdminPageInfo from './AdminPageInfo.vue';
import Axios from 'axios';
import alzuhudLink from "@/components/Functions/Functions";

@Component({
    components: {
        AdminPageInfo,
    }
})
export default class CreatePackage extends Vue {
    private _panelTitle: string;
    @State adminUser: string;
    @State routes: string[];
    @Mutation popRoute: PopRoute;
    @Mutation replaceRoute: ReplaceRoute;
    @State page: number;
    @Mutation incrementPage: () => void;
    @Mutation decrementPage: () => void;
    @Mutation setPage: () => void;
    @Mutation setNumAdults: Function;
    @Mutation setNumChildren: Function;
    @Mutation resetBooking: Function;
    @State tabModel: any;
    @State flight: any;
    @State hotel: any;
    @State userId: any;
    @State title: any;
    @State package: any;
    @State country: any;
    @State city: any;
    @Mutation setPackage: Function;
    @Mutation setHotel: Function;
    @Mutation setFlight: Function;
    @Mutation setPackageId: Function;
    @Getter token: string;
    // hasCreatedPackage: boolean = false;
    date: string = '';
    date2: string = '';
    @State children: any[];
    @State adults: any[];
    @Action snackIt: Function;
    @Mutation selectPackageId: Function;

    get panelTitle() : string {
        if (this.page === 1) {
            return 'Create Your Own Package';
        } else if (this.page === 2) {
            return 'Fill Out The Information';
        } else if (this.page === 3 || this.page === 4) {
            return 'Overview';
        } else if (this.page === 5) {
            return 'Order Completed';
        }

        return 'Create Your Own Package';
    }

    set panelTitle(value: string) {
        this._panelTitle = value;
    }
    
    mounted(): void {
        this.replaceRoute(['Booking', 'Reserve', 'Create Package']);
        this.setNumAdults(0);
        this.setNumChildren(0);
        this.resetBooking();
        this.$router.app.$on('set date', (payload: any) => {

            this.date = payload;
        })

        this.$router.app.$on('set date2', (payload: any) => {
            this.date2 = payload;
        })
        // this.$on('set package', (payload: any) => {
        //     this.date = payload.date;
        //     this.date2 = payload.date2;
        //     this.hasCreatedPackage = true;
        // })
    }
    /**
     *
     */
    constructor() {
        super();
        this.panelTitle = 'Create Your Own Package';
    }
    beforeDestroy(): void {
        this.popRoute();
    }

    async changeStep(type: string): Promise<void> {
        if (type === 'next') {
            if (this.page === 1) {
                if (this.tabModel === 0) {
                    // @ts-ignore
                    if (!!this.title && !!this.date && !!this.date2 && !!this.country) {
                        this.setPackage({
                            name: this.title,
                            // @ts-ignore
                            start_date: this.date,
                            // @ts-ignore
                            end_date: this.date2,
                            // @ts-ignore
                            price: this.hotel.price,
                            creator: this.userId,
                        });
                        try {
                            const response = await Axios.post(`http://${alzuhudLink}:8080/api/packages/add`, {
                                token: this.token,
                                creator: this.userId,
                                // @ts-ignore
                                airline_id: this.flight.id,
                                // @ts-ignore
                                hotel_id: this.hotel.id,
                                // @ts-ignore
                                price: this.hotel.price,
                                name: this.title,
                                // @ts-ignore
                                start_date: this.date,
                                // @ts-ignore
                                end_date: this.date2,
                            });



                            this.selectPackageId(response.data.id);

                        } catch(e) {

                            this.$router.replace('/user-admin/create-package');
                        }

                    } else {
                        this.$router.replace('/user-admin/create-package');
                        return;
                    }
                } else {
                    if (!!this.package && !!this.country && !!this.city) {
                        this.selectPackageId(this.package.id);
                        this.setFlight(this.package.airline_id);
                        this.setHotel(this.package.hotel_id);
                    } else {
                        this.$router.replace('/user-admin/create-package');
                        return;
                    }
                }
            } else if (this.page === 2) {
                let childrenIncomplete = true;
                let adultsIncomplete = true;


                if (this.children.length === 0)
                    childrenIncomplete = false;
                else {
                    for (const child of this.children) {
                        if (!child.full_name || !child.file || !child.gender || !child.date) {
                            break;
                        } else if (this.children.findIndex((ch) => ch === child) === this.children.length - 1) {
                            childrenIncomplete = false;
                        }
                    }
                }
                if (this.adults.length === 0)
                    adultsIncomplete = false;
                else {
                    for (const adult of this.adults) {
                        console.log('enter', this.adults.findIndex((ad) => ad === adult))
                        if (adult.full_name === '' || adult.file === null || adult.gender === '' || adult.date === '') {
                            console.log('enter if');
                            break;
                        } else if (this.adults.findIndex((ad) => ad === adult) === this.adults.length - 1) {
                            console.log('enter else');
                            adultsIncomplete = false;
                        }
                    }
                }

                console.log(childrenIncomplete ,adultsIncomplete, this.adults)

                if (childrenIncomplete || adultsIncomplete) {
                    this.snackIt({
                        message: 'please fill all the required fields',
                        color: 'error',
                        snackbar: true,
                    });
                    return;
                }
            }
            this.incrementPage();
        } else
            this.decrementPage();
        this.$router.push(`/user-admin/create-package/${this.page !== 1 ? `step-${this.page}`: ''}`);
    }

    goToBooking() {
        this.resetBooking();
        this.$router.replace('/user-admin/bookings');
    }

    goToSupport() {
        this.resetBooking();
        this.$router.replace('/user-admin/new-ticket');
    }
}
